//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            loading: true,
            rentalInsurance: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('get-resident-rental-insurance', function () {
            _this.getInsurancePlan();
        });
    },

    methods: {
        getInsurancePlan: function getInsurancePlan() {
            var _this2 = this;

            axios.post('/prototype/resident/get-rental-insurance', { id: this.resident.id }).then(function (response) {
                _this2.loading = false;
                if (response.data) {
                    _this2.rentalInsurance = response.data;
                }
            });
        },
        update: function update(insurance) {
            Event.$emit('change-insurance-plan', insurance);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentRentalInsurance.vue
// module id = 3Wzx
// module chunks = 0 1